/**
 * Centralized types for industries supported by the application.
 * These are the core industries that have specific extraction forms and prompts.
 */

export type Industry =
  | 'banking-financial-services'
  | 'healthcare-life-sciences'
  | 'insurance'
  | 'legal-judiciary'
  | 'retail-member-services'
  | 'food-beverage';

/** True when the org has no industry list, or the industry is in that list. */
export const isIndustryAllowed = (
  industry: Industry | null | undefined,
  enabledIndustries: string[] | null | undefined,
): boolean => {
  if (!industry) return false;
  if (enabledIndustries == null) return true;
  return enabledIndustries.includes(industry);
};

/**
 * Array of all valid industry IDs
 */
export const ALL_INDUSTRIES: Industry[] = [
  'banking-financial-services',
  'healthcare-life-sciences',
  'insurance',
  'legal-judiciary',
  'retail-member-services',
  'food-beverage',
];

/** Order used by the chat industry dropdown and /onboarding industry select (same labels as getIndustryDisplayName). */
export const INDUSTRY_UI_ORDER: Industry[] = [
  'banking-financial-services',
  'insurance',
  'legal-judiciary',
  'healthcare-life-sciences',
  'retail-member-services',
  'food-beverage',
];
